import { render, staticRenderFns } from "./mediateCostTable.vue?vue&type=template&id=22ccad1b&scoped=true&"
import script from "./mediateCostTable.vue?vue&type=script&lang=tsx&"
export * from "./mediateCostTable.vue?vue&type=script&lang=tsx&"
import style0 from "./mediateCostTable.vue?vue&type=style&index=0&id=22ccad1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ccad1b",
  null
  
)

export default component.exports